import React, { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { BellRing, Plus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const AlertRecipients = ({ projectId, initial = [], onSaved }) => {
  const [emails, setEmails] = useState(initial);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async (list) => {
    setSaving(true);
    try {
      const { data } = await api.patch(`/projects/${projectId}/alerts`, { alert_emails: list });
      setEmails(data.alert_emails);
      onSaved?.(data.alert_emails);
      toast.success("Alert recipients saved");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const add = (e) => {
    e.preventDefault();
    const v = value.trim().toLowerCase();
    if (!v || emails.includes(v)) { setValue(""); return; }
    setValue("");
    save([...emails, v]);
  };

  return (
    <div className="mt-6" data-testid="alert-recipients">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-slate-500 mb-2">
        <BellRing className="h-3.5 w-3.5 text-[#F59E0B]" /> Contamination alerts
      </div>
      <p className="text-[11px] text-slate-600 mb-2">You are always notified. Add cooperative / farmer emails to alert them when any compound exceeds MRL.</p>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {emails.map((em) => (
          <span key={em} data-testid={`alert-chip-${em}`} className="flex items-center gap-1 bg-[#F59E0B]/10 border border-[#F59E0B]/30 text-[#F59E0B] text-xs font-mono px-2 py-1">
            {em}
            <button data-testid={`alert-remove-${em}`} onClick={() => save(emails.filter((x) => x !== em))} className="hover:text-white"><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
      <form onSubmit={add} className="flex gap-1.5">
        <input data-testid="alert-email-input" type="email" value={value} onChange={(e) => setValue(e.target.value)} placeholder="farmer@coop.org"
          className="flex-1 bg-[#050A15] border border-white/10 px-3 py-2 text-xs font-mono outline-none focus:border-[#F59E0B]" />
        <button data-testid="alert-email-add" type="submit" disabled={saving || !value}
          className="border border-[#F59E0B]/50 text-[#F59E0B] px-3 hover:bg-[#F59E0B]/10 disabled:opacity-50">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />}
        </button>
      </form>
    </div>
  );
};
